import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./app.scss";
import { DatasPage } from "./pages/datas";
import { LoginPage } from "./pages/login";
import { AuthProvider } from './services/auth.service';

/* -------------------------------------------------------------------------------- *\
|                               App
\* -------------------------------------------------------------------------------- */
export default function App()
{
    return (
        <BrowserRouter basename="/">
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<DatasPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="*" element={<DatasPage />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}
